export default {
  projectName: 'ky-h5-landing',
};
